   <app-payment-notice [canPay]="true"
                       [entityType]="data.entityType"
                       [feeType]="data.feeType"
                       [id]="data.id"
                       [sku]="data.sku"></app-payment-notice>

  <div class="flex flex-row gap-4 mt-4">
    <button class="ml-auto" mat-raised-button color="warn" type="button" (click)="cancel()">Close</button>
  </div>


